import React from "react";
import OtherRouter from "../router/other.js";

const OtherLayout = () => {
  return (
    <div
      className="kt-content kt-grid__item kt-grid__item--fluid"
      id="kt_content"
    >
      <OtherRouter />
    </div>
  );
};

export default OtherLayout;
